"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLightbulbFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M16.57 15H7.438c-.266-.48-.535-.957-.808-1.432C5.526 11.628 5 10.206 5 8.5 5 4.655 8.192 2 11.997 2 15.803 2 19 4.658 19 8.5c0 1.705-.53 3.141-1.634 5.086-.345.608-.603 1.063-.797 1.414h.001zm-.583 2c-.088 3.412-1.158 4.99-3.99 4.99-2.825 0-3.902-1.597-3.99-4.99h7.98zm-.984-7c.996 0 .996-1 .996-1a4 4 0 00-4-4S11 5.001 11 6s1 .999 1 .999c1.08 0 2 .876 2 2.001 0 0 .006 1 1.003 1z' }))); };
exports.default = SvgLightbulbFilled;
//# sourceMappingURL=LightbulbFilled.js.map